import { computed, Injectable } from '@angular/core';
import { selectFolder } from '../../../store/person/person.selectors';
import { FolderStatusEnum } from '../../../../../../../../types/src/services/enum/folder-status.enum';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';

@Injectable()
export class TerminateFolderModalStore extends ComponentStoreV2Factory {

    public folder = this.store!.selectSignal(selectFolder);

    public isApplicant = computed(() => {
        const folder = this.folder();
        return folder?.status === FolderStatusEnum.APPLICANT;
    });

    public isDead = computed(() => {
        const folder = this.folder();
        return [FolderStatusEnum.DEAD, FolderStatusEnum.APPLICANT_DEAD, FolderStatusEnum.DEAD_TERMINATED].includes((folder?.status || '') as any);
    });

}
